import { render, staticRenderFns } from "./AdditionalRecords.vue?vue&type=template&id=0868b064&scoped=true"
import script from "./AdditionalRecords.vue?vue&type=script&lang=js"
export * from "./AdditionalRecords.vue?vue&type=script&lang=js"
import style0 from "./AdditionalRecords.vue?vue&type=style&index=0&id=0868b064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0868b064",
  null
  
)

export default component.exports